// extracted by mini-css-extract-plugin
export default {"editFormButtonWrapper":"ClientNameRenderer_editFormButtonWrapper__t0Y3X","editIcon":"ClientNameRenderer_editIcon__QQpXr"};